import { isNotCalledUpMatch } from './matchCallUpUtils';

/**
 * Sceglie la partita di riferimento per una card rispetto alla finestra torneo/gameweek.
 * Usa next_match, next_match_2 (secondo upcoming in api_match), in_progress, last — così una gameweek
 * "dopo la prossima" può risultare giocabile se il secondo match cade nel range.
 */
export function pickNextMatchForTournamentWindow(bundle, tournamentStart, tournamentEnd) {
  if (!tournamentStart || !tournamentEnd) {
    return { next_match: null, match_id: null, playsInRange: null };
  }
  const startDate = new Date(tournamentStart);
  const endDate = new Date(tournamentEnd);
  // Finestra inclusiva su start/end esatti (es. gameweeks.end_date con ora in DB), senza estendere al 23:59 del giorno.

  const ordered = [
    bundle?.next_match,
    bundle?.next_match_2,
    bundle?.in_progress_match,
    bundle?.last_match
  ].filter((m) => m && !isNotCalledUpMatch(m));

  for (const m of ordered) {
    const d = m?.utcDate ? new Date(m.utcDate) : null;
    if (!d || Number.isNaN(d.getTime())) continue;
    if (d >= startDate && d <= endDate) {
      return {
        next_match: m,
        match_id: m?.id ?? null,
        playsInRange: true
      };
    }
  }

  const fallbackCandidates = [
    bundle?.next_match,
    bundle?.next_match_2,
    bundle?.in_progress_match,
    bundle?.last_match
  ].filter((m) => m && !isNotCalledUpMatch(m));
  const fallback = fallbackCandidates[0] ?? null;
  const fd = fallback?.utcDate ? new Date(fallback.utcDate) : null;
  if (fd && !Number.isNaN(fd.getTime())) {
    return {
      next_match: fallback,
      match_id: fallback?.id ?? null,
      playsInRange: false
    };
  }
  return {
    next_match: fallback,
    match_id: fallback?.id ?? null,
    playsInRange: null
  };
}
